import React from "react";

const TAGS = { ok: "Done", warn: "Check", bad: "Check", info: "Info" };

// The till's single message. Problems are announced at once (alert); the rest politely.
export default function Toast({ toast, onClose }) {
  if (!toast) return null;
  const urgent = toast.tone === "warn" || toast.tone === "bad";
  return (
    <div key={toast.id} className={`fp-toast fp-toast-${toast.tone}`} role={urgent ? "alert" : "status"}>
      <span className={`fp-pill p-${toast.tone}`}>{TAGS[toast.tone] || "Info"}</span>
      <span className="fp-toast-text">{toast.text}</span>
      {toast.actions?.length > 0 && (
        <span className="fp-toast-acts">
          {toast.actions.map((a) => (
            <button
              key={a.label}
              type="button"
              className="fp-toast-act"
              onClick={() => {
                onClose?.();
                a.onClick();
              }}
            >
              {a.label}
            </button>
          ))}
        </span>
      )}
      {onClose && (
        <button type="button" className="fp-toast-x" aria-label="Dismiss message" onClick={onClose}>
          ×
        </button>
      )}
    </div>
  );
}
